export enum UNSYNCED_TIME_ZONES {
  ASIA_KOLKATA = "Asia/Kolkata",
  ASIA_CALCUTTA = "Asia/Calcutta",
  ASIA_ULAANBATAAR = "Asia/Ulaanbaatar",
  ASIA_ULANBATOR = "Asia/Ulan_Bator",
}
